import React, { ChangeEventHandler, useContext, useEffect, useState } from "react";
import * as Yup from "yup";
import { ContentState } from "../../../../../models/SKArtifact";
import { CreateArtifactContext } from "../../../../../context/CreateArtifactContext";
import { BASE_API_URL } from "../../../../../config";
import { fetchFaviconImage } from "../../../../../utils";

interface LinkMetadataProviderWidgetProps {
  index: number;
  title: string;
  note: string;
  placeholder: string;
  charAllowed: number;
  isClear: boolean;
  webAddress?: string;
  onChange: (
    data: {
      id: string;
      title: string;
      description: string;
      image: string;
      url: string;
      bufferImage: string;
    },
    actualURL: string
  ) => void;
}

export const LinkMetadataProviderWidget = ({
  onChange,
  index,
  title,
  note,
  placeholder,
  charAllowed,
  isClear,
  webAddress,
}: LinkMetadataProviderWidgetProps) => {
  const { contentData, updateContentData, artifactId, submit, containerButtonTitle } = useContext(CreateArtifactContext);
  const [searchURL, setSearchURL] = useState(webAddress ?? "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>("");
  var [enableAutoSearch, setEnableAutoSearch] = useState(false);
  const [urlData, setUrlData] = useState<{
    id?: string;
    title?: string;
    description?: string;
    image?: string;
    url?: string;
    bufferImage?: string;
  }>({});
  const schema = Yup.object().shape({
    title: Yup.string().required(`Title is required!`).max(100),
    image: Yup.string().required(`Image is required!`),
  });
  const pattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;

  function isValidUrl(url: string): boolean {
    return !!pattern.test(url);
  }

  useEffect(() => {
    const validate = async () => {
      try {
        await schema.validate(urlData, { abortEarly: false });
        setError("");
      } catch (err) {
        // setError("Please enter a valid URL");
      }
    };
    validate();
  }, [urlData, schema]);

  // useEffect(() => {
  //   if (searchURL.length > 0) {
  //     const normalizedUrl = normalizeAndValidateUrl(searchURL);
  //     if (normalizedUrl) {
  //       setSearchURL(normalizedUrl);
  //       setError("");
  //     } else {
  //       setError("Please enter a valid URL");
  //     }
  //   } else {
  //     setError("");
  //   }
  // }, [searchURL]);

  if (isClear && searchURL) {
    setSearchURL("");
  }

  function normalizeAndValidateUrl1(urlString: string): string | null {
    let url = urlString.trim();

    // Add https:// if no protocol is provided
    if (!/^https?:\/\//i.test(url)) {
      url = "https://" + url;
    }

    try {
      const validatedUrl = new URL(url); // Throws if invalid
      return validatedUrl.href; // Returns fully normalized URL
    } catch (err) {
      return null; // Invalid URL
    }
  }

  function normalizeAndValidateUrl(urlString: string): string | undefined {
    let normalizedUrl = urlString.trim();
    if (!/^https?:\/\//i.test(normalizedUrl)) {
      normalizedUrl = "https://" + normalizedUrl;
    }

    try {
      const url = new URL(normalizedUrl);
      // Basic TLD presence check (e.g., domain.com)
      if (!/\.[a-z]{2,}$/i.test(url.hostname)) {
        return undefined;
      }
      return url.href;
    } catch {
      return undefined;
    }
  }

  const findOGTag = async (url: string) => {
    setLoading(true);
    setUrlData({});
    try {
      //https://us-central1-skarvostore.cloudfunctions.net/
      const apiUrl = `${BASE_API_URL}/fetchOgTags?url=${encodeURIComponent(url)}`;
      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();

      setUrlData(data || {});
      return data;
    } catch (error) {
      console.error("Error fetching OG data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div
            id="dataLoader"
            className="flex flex-col items-center justify-center p-4 space-y-2 text-center bg-white shadow-sm w-44 h-44 rounded-2xl"
          >
            <img src={"/icons/mediaupload.gif"} alt="Saving" className="w-10 h-10" />
            <div className="font-bold text-center text-gray-400">Loading...</div>
            <button
              className="px-4 py-2 text-black border border-gray-400 rounded-md"
              onClick={e => {
                e.stopPropagation();
                setLoading(false);
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      <div className="relative w-full min-w-[200px]">
        {title && (
          <div className="flex items-center">
            <span>{index && <span className="content_count">{index}</span>}</span>
            {title && <span className="content_title">{title}</span>}
          </div>
        )}
        {note && <div className="notes-class-content">{note}</div>}
        {/* <div className="flex min-w-0 overflow-auto input-class">
          <textarea
            name="listName"
            id="listName"
            className="w-full overflow-auto whitespace-pre-line input-text"
            placeholder={placeholder}
            required
            //maxLength={charAllowed}
            value={searchURL}
            onChange={async (e) => {
              setSearchURL(e.target.value);
              isValidUrl(e.target.value)
                ? setEnableAutoSearch(true)
                : setEnableAutoSearch(false);
            }}
            disabled={contentData.status === State.review}
          ></textarea>
        </div> */}
        <div className="flex min-w-0 overflow-auto input-class">
          <input
            type="text"
            name="listName"
            id="listName"
            className="w-full overflow-auto input-text whitespace-nowrap"
            placeholder={placeholder}
            required
            maxLength={charAllowed}
            value={searchURL}
            onChange={async e => {
              setSearchURL(e.target.value);
              normalizeAndValidateUrl(e.target.value) ? setEnableAutoSearch(true) : setEnableAutoSearch(false);
            }}
            disabled={contentData.status === ContentState.IN_REVIEW}
          />
        </div>

        {error && <span className="error-characters">{error}</span>}
        {/* {!error && (
          <span className="remaining-characters">
            {charAllowed - (searchURL.length ?? 0)} Characters Remaining.
          </span>
        )} */}

        <div className="flex justify-end w-full mt-[15px] max-w-[480px]">
          <button
            className={
              (enableAutoSearch ? " bg-black " : " bg-gray-400  disabled-link ") +
              "flex items-center justify-center px-3 py-1 text-sm font-normal text-center text-white rounded-lg w-[68px] h-[32px]"
            }
            onClick={async () => {
              // onChange({ id: "", title: "", description: "", image: "", url: "", bufferImage: "" }, searchURL);
              const data = await findOGTag(normalizeAndValidateUrl(searchURL) ?? "");
              onChange(data, searchURL);
              setEnableAutoSearch(false);
            }}
          >
            Get
          </button>
        </div>
      </div>
    </>
  );
};
